import React from 'react';
import { BOX_IMAGE } from '../data/site';
export function SolutionSection() {
  const scrollToOffer = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    document.getElementById('offerta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-brand-navy px-4 py-7 text-white" data-id="element-190" data-mp="3o6xuebyolvc2">
      <div className="mx-auto max-w-2xl text-center" data-id="element-191" data-mp="3j9fpcwnsc09c">
        <p className="text-xs font-extrabold uppercase tracking-widest text-brand-orange sm:text-sm" data-id="element-192" data-mp="14cltgdgvwb1">
          La soluzione che stavi cercando
        </p>

        <h2 className="mt-1.5 font-display text-xl font-extrabold uppercase leading-tight text-white sm:text-2xl" data-id="element-193" data-mp="3t850m6l6emgm">
          Un sistema completo 6-in-1 pronto all’uso per insegnanti di inglese
        </h2>

        <p className="mt-2 font-display text-2xl font-extrabold uppercase text-brand-green sm:text-3xl" data-id="element-194" data-mp="5xe2ntx8i5x9">
          ENGLISH TEACHER PRO™
        </p>

        <a href="#offerta" onClick={scrollToOffer} className="mt-3 block" data-id="element-195" data-mp="fua0n5pib9nk">
          <img src={BOX_IMAGE} alt="Box ENGLISH TEACHER PRO™" className="mx-auto w-full max-w-[240px] drop-shadow-2xl" data-id="element-196" data-mp="36am3bk8j0u2w" />
        </a>

        <div className="mt-3 space-y-1 text-[15px] font-medium leading-snug text-white/85" data-id="element-197" data-mp="3bbtbhkekzva3">
          <p data-id="element-198" data-mp="3fdes9gu8ktpk">Non una raccolta casuale di esercizi.</p>
          <p data-id="element-199" data-mp="3kanb7jn7l1rv">Non semplicemente qualche lesson plan.</p>
          <p data-id="element-200" data-mp="3k80v2vm95dy1">Non materiale che devi ancora completare da solo.</p>
        </div>

        <p className="mt-3 text-[15px] font-medium leading-snug text-white" data-id="element-201" data-mp="3p983mww7yh5r">
          ENGLISH TEACHER PRO™ riunisce in un unico sistema lezioni, grammatica,
          vocabolario, speaking, reading, writing, attività, giochi, valutazioni e
          strumenti di pianificazione pronti da selezionare e utilizzare.
        </p>

        <div className="mx-auto mt-4 max-w-md rounded-lg border-2 border-white/20 bg-white/10 p-3.5" data-id="element-202" data-mp="buljrigbev29">
          <p className="text-sm font-bold" data-id="element-203" data-mp="gtoeoa2kzkwi">Creato per aiutarti a passare da:</p>
          <p className="mt-1 text-[15px] font-medium italic text-white/85" data-id="element-204" data-mp="grk81kdas7sj">
            “Cosa preparo per la prossima lezione?”
          </p>
          <p className="mt-1.5 text-sm font-bold" data-id="element-205" data-mp="27yhsr506t8jk">a:</p>
          <p className="mt-1 font-display text-base font-extrabold uppercase text-brand-orange sm:text-lg" data-id="element-206" data-mp="27vnbtngdu5uw">
            Apri → Scegli → Adatta → Insegna.
          </p>
        </div>

        <div className="mt-4 space-y-2 text-[13px] font-medium leading-snug text-white/75" data-id="element-207" data-mp="2hul5t5wkurla">
          <p data-id="element-208" data-mp="2vlpz7q9cqnn6">
            Tutto il materiale didattico incluso in ENGLISH TEACHER PRO™ è
            fornito in inglese, pronto per essere utilizzato direttamente nelle
            tue lezioni.
          </p>
          <p data-id="element-209" data-mp="35kp7v8u4aja6">
            Il sistema non segue un singolo programma scolastico nazionale ed è
            stato sviluppato per essere utilizzabile in diversi contesti di
            insegnamento dell’inglese.
          </p>
        </div>
      </div>
    </section>;
}